import async from "../components/Async";
import Landing from "../containers/landing";

// Pages
import AboutPage from "../containers/pages/about/About";
import AgreementPage from "../containers/pages/legal/Agreement";
import PrivacyPolicyPage from "../containers/pages/legal/Privacypolicy";
import ClassRequestFormPage from "../containers/pages/class/ClassRequestForm";
// import ALevelPage from "../containers/pages/class/ALevel";
import IBPage from "../containers/pages/class/IB";
// import APPage from "../containers/pages/class/AP";
import IGCSEPage from "../containers/pages/class/IGCSE";
// import SATPage from "../containers/pages/class/SAT";
import IELTSPage from "../containers/pages/class/IELTS";
import UniadmPage from "../containers/pages/class/Uniadm";
import CareerPage from "../containers/pages/career/Career";
import LoginContainer from "../containers/auth/LoginContainer";
import KakaoAuth from "../components/auth/KakaoAuth";

import DataScienctist from "../containers/pages/career/categories/DataScientist";
import Elonmusk from "../containers/pages/career/categories/Elonmusk";
import Cosmetics from "../containers/pages/career/categories/Cosmetics";
import Doctor from "../containers/pages/career/categories/Doctor";
import Blockchain from "../containers/pages/career/categories/Blockchain";
import Economics from "../containers/pages/career/categories/Economics";

import PremiumCoursePayment from "../containers/pages/payments/PremiumCoursePayment";
import PremiumClassrooms from "../containers/pages/classrooms/PremiumClassrooms";

const ALevelPage = async(() => import("../containers/pages/class/ALevel"));

// Auth
const Login = async(() => import("../containers/auth/Login"));

const Register = async(() => import("../containers/auth/Register"));
const RegisterTeacherForm = async(() =>
  import("../containers/auth/RegisterTeacherForm")
);
//import ResetPassword from "../containers/auth/ResetPassword";

// Dashboard
// const DashboardMain = async(() => import("../containers/dashboard"));
// const DashboardBoard = async(() => import("../containers/dashboard/board/Board"));
// const DashboardList = async(() => import("../containers/dashboard/list"));
// const DashboardMap = async(() => import("../containers/dashboard/map"));
// const DashboardStats = async(() => import("../containers/dashboard/stats"));

// Routes

//Main routes
// const dashboardBoardRoute = {
//     path: "/dashboard/board",
//     component: DashboardBoard
// };

// const dashboardListRoute = {
//     path: "/dashboard/list",
//     component: DashboardList
// };

//Page routes
const landingPageRoute = {
  path: "/",
  component: Landing,
};

const careerPageRoute = {
  path: "/career",
  component: CareerPage,
};

const careerDSPage = {
  path: "/page/career/data_scientist",
  component: DataScienctist,
};
const careerElonMuskPage = {
  path: "/page/career/elon_musk",
  component: Elonmusk,
};
const careerCosmeticPage = {
  path: "/page/career/cosmetic_create",
  component: Cosmetics,
};
const careerEconomicsPage = {
  path: "/page/career/economics",
  component: Economics,
};
const careerDoctorPage = {
  path: "/page/career/doctor",
  component: Doctor,
};
const careerBlockchainPage = {
  path: "/page/career/blockchain",
  component: Blockchain,
};

const aboutPageRoute = {
  path: "/page/about",
  component: AboutPage,
};

const agreementPageRoute = {
  path: "/page/agreement",
  component: AgreementPage,
};

const privacyPolicyPageRoute = {
  path: "/page/privacypolicy",
  component: PrivacyPolicyPage,
};

const classRequestFormRoute = {
  path: "/page/class/request",
  component: ClassRequestFormPage,
};

const ALevelPageRoute = {
  path: "/page/class/alevel",
  component: ALevelPage,
};

const IBPagePageRoute = {
  path: "/page/class/ib",
  component: IBPage,
};

const paymentPremiumCourseRoute = {
  path: "/payment/premium_course",
  component: PremiumCoursePayment,
};

const PremiumClassroomsRoute = {
  path: "/page/classrooms/premium_classrooms",
  component: PremiumClassrooms,
};

// const APPageRoute = {
//     path: "/page/class/ap",
//     component: APPage
// };

const IGCSEPageRoute = {
  path: "/page/class/igcse",
  component: IGCSEPage,
};

// const SATPageRoute = {
//     path: "/page/class/sat",
//     component: SATPage
// };

const IELTSPageRoute = {
  path: "/page/class/ielts",
  component: IELTSPage,
};

const UniadmPageRoute = {
  path: "/page/class/uniadm",
  component: UniadmPage,
};

//Auth routes
const loginRoute = {
  path: "/auth/login",
  component: Login,
};
const googleLoginRoute = {
  path: "/auth/oauth_login",
  component: LoginContainer,
};

const kakaoCallbackRoute = {
  path: "/auth/kakao/callback",
  component: KakaoAuth,
};

const registerRoute = {
  path: "/auth/register",
  component: Register,
};

const registerTeacherRoute = {
  path: "/auth/teacher",
  component: RegisterTeacherForm,
};

// {
//     path: "/auth/resetpassword",
//     component: ResetPassword
// }

export const authRoutes = [
  loginRoute,
  registerRoute,
  registerTeacherRoute,
  googleLoginRoute,
  kakaoCallbackRoute,
];

export const pageRoutes = [
  landingPageRoute,
  careerPageRoute,
  aboutPageRoute,
  agreementPageRoute,
  privacyPolicyPageRoute,
  classRequestFormRoute,
  ALevelPageRoute,
  IBPagePageRoute,
  // APPageRoute,
  IGCSEPageRoute,
  // SATPageRoute,
  IELTSPageRoute,
  UniadmPageRoute,
  careerDSPage,
  careerElonMuskPage,
  careerCosmeticPage,
  careerEconomicsPage,
  careerDoctorPage,
  careerBlockchainPage,
  PremiumClassroomsRoute,
];

export const paymentPageRoutes = [paymentPremiumCourseRoute];

export const mainRoutes = [
  // dashboardListRoute,
  // dashboardBoardRoute
];
